import { render, staticRenderFns } from "./SimpleTeacherCard.vue?vue&type=template&id=0fdf751b&scoped=true&"
import script from "./SimpleTeacherCard.vue?vue&type=script&lang=js&"
export * from "./SimpleTeacherCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTeacherCard.vue?vue&type=style&index=0&id=0fdf751b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf751b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VHover,VRow})
